import { render, staticRenderFns } from "./Octocat.vue?vue&type=template&id=b7bf9a68&scoped=true&"
var script = {}
import style0 from "./Octocat.vue?vue&type=style&index=0&id=b7bf9a68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bf9a68",
  null
  
)

export default component.exports